import { call, put, takeLatest } from 'redux-saga/effects';
import { userDetailPageActions as actions } from '.';
import fetchClient from 'utils/requestInterceptor';
import { API_ENDPOINTS } from 'utils/configs';
import { PayloadAction } from '@reduxjs/toolkit';
import { User, UserPageCompanyInfo } from 'types/models';
import { UpdateUserDetailAction } from './types';
import {
  handleGeneralGET,
  handleGeneralGETFnType,
} from 'utils/saga-helper/generalRequest';
import {
  displayError,
  displaySuccessToaster,
} from 'app/components/ToasterBar/helpers';
import { UserToasterMsg } from 'app/components/ToasterBar/constants';

// const {
//   user: { resetPwd },
// } = UrlFragments;

export function* fetchUserDetailSaga(action: PayloadAction<string>) {
  yield call<handleGeneralGETFnType<User>>(
    handleGeneralGET,
    actions.fetchUserDetailSucceeded,
    actions.fetchUserDetailFailed,
    API_ENDPOINTS.USER + action.payload,
  );
}

export function* fetchUserPageCompanyInfoSaga(action: PayloadAction<string>) {
  try {
    const { data }: { data: UserPageCompanyInfo } = yield call(
      fetchClient.get,
      API_ENDPOINTS.USER + action.payload + API_ENDPOINTS.USER_COMPANY,
    );
    yield put(actions.fetchUserPageCompanyInfoSucceeded(data));
  } catch (err: any) {
    if (err?.response?.status && err?.response?.status !== 404) {
      yield call(displayError, err);
    }
    yield put(actions.fetchUserPageCompanyInfoFailed());
  }
}

//TODO: Uncomment when implement
// export function* resetPasswordSaga(
//   action: PayloadAction<IRequestConfDialogActionType>,
// ) {
//   if (action.payload.type !== confirmDialogTypeEnum.reset_pwd) {
//     return;
//   }

//   try {
//     yield call(
//       fetchClient.post,
//       API_ENDPOINTS.USER +
//         (action.payload.data as resetPwdDataType).user_id +
//         `/${resetPwd}`,
//     );
//     yield put(cfDialogActions.confDialogActionSucceed());
//   } catch (err) {
//     console.log(err);
//     yield put(cfDialogActions.confDialogActionFailed());
//   }
// }

export function* updateUserDetailSaga(
  action: PayloadAction<UpdateUserDetailAction>,
) {
  try {
    const { data }: { data: User } = yield call(
      fetchClient.put,
      API_ENDPOINTS.USER + action.payload.id,
      action.payload.updatedUserDetail,
    );
    yield put(actions.updateUserDetailSucceeded(data));
    yield call(
      displaySuccessToaster,
      UserToasterMsg.UPDATE_USER_DETAIL_SUCCEED,
    );
  } catch (err) {
    yield call(displayError, err);
  }
}

export function* userDetailPageSaga() {
  yield takeLatest(actions.fetchUserDetail.type, fetchUserDetailSaga);
  // yield takeLatest(
  //   cfDialogActions.requestConfDialogAction.type,
  //   resetPasswordSaga,
  // );
  yield takeLatest(actions.updateUserDetail.type, updateUserDetailSaga);
  yield takeLatest(
    actions.fetchUserPageCompanyInfo.type,
    fetchUserPageCompanyInfoSaga,
  );
}
